export default "__VITE_ASSET__7130a41f__"